import { jwtDecode } from 'jwt-decode'

const USER_INFO_KEY = 'userInfo'

export const getStoredUserInfo = () => {
  try {
    const rawUserInfo = localStorage.getItem(USER_INFO_KEY)
    return rawUserInfo ? JSON.parse(rawUserInfo) : null
  } catch (error) {
    localStorage.removeItem(USER_INFO_KEY)
    return null
  }
}

export const clearStoredUserInfo = () => {
  localStorage.removeItem(USER_INFO_KEY)
}

export const setStoredUserInfo = (userInfo) => {
  localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo))
}

export const getTokenExpiration = (token) => {
  try {
    return jwtDecode(token).exp || 0
  } catch (error) {
    return 0
  }
}

export const hasUsableSession = (userInfo, skewSeconds = 30) => {
  if (!userInfo?.access || !userInfo?.refresh) return false
  const expiresAt = getTokenExpiration(userInfo.access)
  if (!expiresAt) return false
  return expiresAt > ((Date.now() / 1000) + skewSeconds)
}

export const hasRefreshToken = (userInfo) => Boolean(userInfo?.refresh)
